import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Briefcase, Zap, Heart, Sparkles, Target, Layers } from 'lucide-react';

export default function CompanyCareers() {
  return (
    <SubpageTemplate 
      title="Careers"
      subtitle="Join the Revolution"
      description="We're looking for ambitious builders who want to redefine how software is created. If you're bored of building the same CRUD apps, come help us build the builder."
      icon={Briefcase}
      features={[
        {
          title: "Hard Problems",
          description: "Work on the intersection of generative AI, visual programming, and cloud infrastructure.",
          icon: Zap
        },
        {
          title: "Equity & Ownership",
          description: "Every member of our crew is an owner. We win together or not at all.",
          icon: Target
        },
        {
          title: "Infinite Learning",
          description: "Annual synthesis budget for any books, courses, or gear you need to stay at the edge.",
          icon: Sparkles
        }
      ]}
    />
  );
}
